module.exports = __webpack_public_path__ + "6e42d18b107cd420beb72d1d34d375db.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/request-center/approvals/approvals.html
// module id = 2604
// module chunks = 0